import { notification } from 'antd';
import { Copy } from 'lucide-react';
import type { FC } from 'react';

interface TruncatedIdProps {
  id: string;
  label?: string;
  truncateAt?: number;
}

export const TruncatedId: FC<TruncatedIdProps> = ({ id, label = 'ID', truncateAt = 7 }) => {
  const truncated = id ? `${id.slice(0, truncateAt)}...` : '—';

  const handleCopy = () => {
    navigator.clipboard.writeText(id).then(() => {
      notification.success({
        message: 'Copied to clipboard',
        duration: 2,
        pauseOnHover: false,
        className: 'custom-success-notifications bold-notification-message',
      });
    });
  };

  return (
    <div className="flex items-center gap-2 text-[12px] text-[#546E7A]">
      <span className="font-semibold text-[14px] text-[#0B0B0B]">{label}:</span>
      <span className="font-mono">{truncated}</span>
      <button
        aria-label="Copy full ID to clipboard"
        className="flex items-center justify-center text-[#546E7A] hover:text-[var(--primary-gold)] transition-colors cursor-pointer"
        type="button"
        onClick={handleCopy}
      >
        <Copy size={14} />
      </button>
    </div>
  );
};
